export const isSSR = () => {
    const returnValue = !(typeof window != 'undefined' && window.document);
    return returnValue;
};
